Handlebars.registerHelper('compare', function (lvalue, operator, rvalue, options) {
	var operators, result;

    if (arguments.length < 3) {
        throw new Error("Handlerbars Helper 'compare' needs 2 parameters");
    }

    if (options === undefined) {
        options = rvalue;
        rvalue = operator;
        operator = "===";
    }

    operators = {
        '==': function (l, r) { return l == r; },
        '===': function (l, r) { return l === r; },
        '!=': function (l, r) { return l != r; },
        '!==': function (l, r) { return l !== r; },
        '<': function (l, r) { return l < r; },
        '>': function (l, r) { return l > r; },
        '<=': function (l, r) { return l <= r; },
        '>=': function (l, r) { return l >= r; },
        '||': function (l, r) { return l || r; },
        '&&': function (l, r) { return l && r; },
        'hasOwnProperty': function (l, r) { return l.hasOwnProperty(r); },
        'typeof': function (l, r) { return typeof l == r; },
        'nottypeof': function (l, r) { return typeof l != r; },
        'contains': function (l, r) {return l && l.indexOf(r) > -1; },
        'islast': function (l, r) {return l+1 >= r; },
        'indexOf': function (l, r) {return l.indexOf(r); },
        'indexOfJSONObject': function (l, r) {
            for (var i = 0; i < l.length; i++) {
                if (JSON.stringify(l[i]) == JSON.stringify(r)) {
                    return i;
                }
            }
            return -1;
        },
        'containsJSONObject': function (l, r) {
            for (var i = 0; i < l.length; i++) {
                if (JSON.stringify(l[i]) == JSON.stringify(r)) {
                    return true;
                }
            }
            return false;
        }
    };

    if (!operators[operator]) {
        throw new Error("Handlerbars Helper 'compare' doesn't know the operator " + operator);
    }

    result = operators[operator](lvalue, rvalue);

    if (result) {
        return options.fn(this);
    } else {
        return options.inverse(this);
    }

});

Handlebars.registerHelper('replace', function(str, searchString, replaceString) {
	return str.replace(searchString, replaceString);
});

Handlebars.registerHelper('embed', function(templateName) {
	// CAUTION:
	// must include all subtemplates on the page
	// do not create looping templates!
	try {
		var template = Handlebars.templates[templateName];
	    var html = template(this);
	    return new Handlebars.SafeString(html);
	} catch(e) {
		"There is an error embedding template " + templateName + ": " + e.message;
	}

});

Handlebars.registerHelper('defValue', function (value, def) {
	var out = value || def;
	return new Handlebars.SafeString(out);
});

Handlebars.registerHelper('removeNonAlphaNumericChars', function(text) {
	return removeNonAlphaNumericChars(text);
});

Handlebars.registerHelper('escapeQuotes', function(str) {
	return str.replace(/(['"])/g, '\\$1');
});

Handlebars.registerHelper('encodeURIComponent', function(url) {
	return encodeURIComponent(url);
});

Handlebars.registerHelper('capitalize', function(str) {
	if (!str) {
		return "";
	}
	return str.capitalizeFirstLetter();
});

Handlebars.registerHelper('formatCurrency', function(amount,style) {
	if (style == "ceil") {
		return formatCurrency( parseInt(Math.ceil(parseFloat(amount))) ).split(".")[0];
	} else {
		var x = parseFloat(amount);
		return formatCurrency( x.toFixed(2) );
	}
});

Handlebars.registerHelper('formatCurrencyLeaveOff0Cents', function(amount) {
	var x = parseFloat(amount);
	return formatCurrency( x.toFixed(2), true);

});

Handlebars.registerHelper('ceil', function(amount) {
	return parseInt(Math.ceil(parseFloat(amount)));
});

Handlebars.registerHelper('modulo', function(index,mod) {
	return index % mod;
});

Handlebars.registerHelper('substring', function(textString,start,end) {
	if (textString.length > end && end > start) {
		return textString.substring(start,end);
	}
	return textString;
});

Handlebars.registerHelper('substringPretty', function(textString,start,end) {
	if (textString.length > end && end > start) {
		textString = textString.substring(start,end);
		textString = textString.substring(0,textString.lastIndexOf(" ")) + "...";
	}
	return new Handlebars.SafeString(textString);
});

Handlebars.registerHelper('plural', function(numberString, textString) {
	var num = parseInt(numberString);
	if (num == 1) {
		return textString;
	}
	return textString + "s";
});

Handlebars.registerHelper('setURLParam', function(fullURL,param,newValue) {
	return setURLParam(fullURL,param,newValue);
});


Handlebars.registerHelper('ifLoggedInOrCookied', function(bool,options) {
	var loggedInOrCookied = (!!isLoggedIn() || readCookie("userId") != null) === bool;
	if (loggedInOrCookied) {
		return options.fn(this);
  } else {
    return options.inverse(this);
	}
});

Handlebars.registerHelper('trackingLink', function(fullURL, campaign, pageSource) {
	return getTrackingLink(fullURL, campaign, pageSource);
});

Handlebars.registerHelper('trackingLinkDecoded', function(fullURL, campaign, pageSource) {
	return decodeURIComponent(getTrackingLink(fullURL, campaign, pageSource));
});

Handlebars.registerHelper('formatMediumDate', function(theDate) {
	var medDate = new Date(theDate);
	return medDate.getShortMonthName() + " " + medDate.getDate() + ", " + medDate.getFullYear();
});

Handlebars.registerHelper('formatDate', function(theDate) {
	var medDate = new Date(theDate);
	return medDate.getMonthName() + " " + medDate.getDate() + ", " + medDate.getFullYear();
});

/**
 * Converts a 9-or-10-digit string into a hyphen-delimited phone number.
 * Leaves all other formats alone.
 */
Handlebars.registerHelper('formatPhoneNumber', function(number) {
	return number && number.replace(/^1?(\d{3})(\d{3})(\d{4})$/, '($1) $2-$3');
});

Handlebars.registerHelper('titleCase', function(words) {
	return words && (words.replace(/\w\S*/g, function(txt){
		return txt.charAt(0).toUpperCase() + txt.slice(1).toLowerCase();
	}));
});

Handlebars.registerHelper('expired', function(expirationDate,options) {
	var now = new Date();
	var year = parseInt(expirationDate.split("-")[0],10);
	var month = parseInt(expirationDate.split("-")[1],10) - 1;
	var date = parseInt(expirationDate.split("-")[2],10);
	var exp = new Date(year,month,date);

	if (now.getTime() > exp.getTime()) {
		return options.fn(this);
	} else {
		return options.inverse(this);
	}
});

Handlebars.registerHelper('queryStringParam', function(param, fullURL) {
	if (!param) return "";
	// This check is necessary because fullURL is optional, but Handlebars passes
	// an object as an implicit last param. We only want to use fullURL if it's a string.
	var url = (typeof fullURL === "string" && fullURL) ? fullURL : location.href;
	var paramValue = getURLParam(url, param);
	return (paramValue != null) ? paramValue : "";
});

Handlebars.registerHelper('bestQueryStringParam', function(param, param2, fullURL) {
	if (!param && !param2) return "";
	// This check is necessary because fullURL is optional, but Handlebars passes
	// an object as an implicit last param. We only want to use fullURL if it's a string.
	var url = (typeof fullURL === "string" && fullURL) ? fullURL : location.href;
	var paramValue = getURLParam(url, param);
	return (paramValue != null) ? paramValue : getURLParam(url, param2);
});


/* STATIC VARIABLES */

Handlebars.registerHelper('pageName', function() {
	if (typeof pageName != "undefined") {
		return pageName;
	} else {
		return "unknown";
	}
});

Handlebars.registerHelper('baseURL', function() {
	if (typeof baseURL != "undefined") {
		return baseURL;
	} else {
		return "https://www.donorschoose.org/";
	}
});

Handlebars.registerHelper('baseCacheURL', function() {
	if (typeof baseCacheURL != "undefined") {
		return baseCacheURL;
	} else {
		return "https://cdn.donorschoose.net/";
	}
});

Handlebars.registerHelper('secureBaseURL', function() {
	if (typeof secureBaseURL != "undefined") {
		return secureBaseURL;
	} else {
		return "https://secure.donorschoose.org/";
	}
});

Handlebars.registerHelper('baseS3URL', function() {
	if (typeof baseS3URL != "undefined") {
		return baseS3URL;
	} else {
		return "https://storage.donorschoose.net/";
	}
});

Handlebars.registerHelper('facebookAppId', function() {
	if (typeof facebookAppId != "undefined") {
		return facebookAppId;
	} else {
		return "44550081712";
	}
});


/* SEARCH PAGE */


Handlebars.registerHelper('removeOneLink', function(breadcrumb,searchURL) {
	var removeString = "";
	for (var i=0; i< breadcrumb.length; i++) {
		if (breadcrumb[i][2] != null && breadcrumb[i][2] != "") {
			var removeOneURL = setURLParam(searchURL,breadcrumb[i][0],null);
			if (breadcrumb[i][0] == "keywords") {
				removeOneURL = setURLParam(removeOneURL,"widenRetry",null);
			}
			removeString += '<li><a onclick="dcAnalytics.trackEventGA([\'Search\', \'No Results\', \'Remove One Parameter\']);" href="'+removeOneURL+'">remove: '+breadcrumb[i][2]+'</a></li>';
		}
	}

	if (removeString != "") removeString = "<ul>" + removeString + "</ul>";
	else removeString = '<ul><li><a onclick="dcAnalytics.trackEventGA([\'Search\', \'No Results\', \'Remove One Parameter\']);" href="'+baseURL+'donors/search.html">Most urgent projects</a></li></ul>';
	return removeString;
});


Handlebars.registerHelper('showFullLocation', function(options) {
	// TODO: add locationSearchTest
	if(this.thankYouAssets && this.thankYouAssets.photos && this.thankYouAssets.photos.length > 0) {
	    return options.inverse(this);
	} else {
	    return options.fn(this);
	}
});

Handlebars.registerHelper('calloutMatches', function() {

	var qs = getQueryStringParams(window.location.search.substring(1),"&");
	var callouts = "";

	if (qs["subject1"] != null || qs["subject2"] != null || qs["subject3"] != null || qs["subject4"] != null || qs["subject5"] != null || qs["subject6"] != null) {
		callouts += "<br />" + this.subject.name;
		if (this.hasOwnProperty("additionalSubjects")) {
			for (var i = 0; i < this.additionalSubjects.length; i++)
				callouts += ", " + this.additionalSubjects[i].name;
		}
	}
	if (qs["freeShipping"] != null) {
		callouts += "<br />Free Shipping";
	}
	if (qs["proposalType"] != null) {
		callouts += "<br />" + this.resource.name;
	}
	if (qs["gradeType"] != null) {
		callouts += "<br />" + this.gradeLevel.name;
	}
	if (qs["teacherType"] != null) {
		for (var i in this.teacherTypes) {
			if (this.teacherTypes[i].id == qs["teacherType"])
				callouts += "<br />" + this.teacherTypes[i].type;
		}
	}
	if (qs["schoolType"] != null) {
		for (var i in this.schoolTypes) {
			if (this.schoolTypes[i].id == qs["schoolType"])
				callouts += "<br />" + this.schoolTypes[i].name;
		}
	}
	if (qs["teacherNotFunded"] != null) {
		callouts += "<br />Teacher Never before funded";
	}

	return  new Handlebars.SafeString(callouts);
});

/* SHAREBAR */

Handlebars.registerHelper('getTafURL', function(id,lightbox) {
	return getTafURL(id,lightbox);
});

Handlebars.registerHelper('isOptTestBucket', function(bucketType, options) {
	var result = false;
	if (window.optimizelyTestBucket && window.optimizelyTestBucket == bucketType) {
		result = true;
	}
	if (result) {
		return options.fn(this);
	} else {
		return options.inverse(this);
	}
});

Handlebars.registerHelper('locationAndDonorTeacherRelationshipForDonationHistory', function(location, donorTeacherRelationship) {
	return proposalMessageFormatter.getLocationAndDonorTeacherRelationship(location, donorTeacherRelationship);
});

